import * as React from 'react';
import { MenuItem, OutlinedInput, Select, FormControl, Menu, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';




export default function Range({ name, array, onSelect }) {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [minPrice, setMinPrice] = React.useState('');
  const [maxPrice, setMaxPrice] = React.useState('');

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelectMin = (value) => {

    setMinPrice(value);
    if (onSelect) {
      console.log("value", Number(value));

      onSelect(`${name}_from`,value); // Sending name and item to parent
    }
  };

  const handleSelectMax = (value) => {
    setMaxPrice(value);
    if (onSelect) {
      console.log(Number(value));

      onSelect(`${name}_to`, value); 
    }
  };

  return (
    <>
      <FormControl sx={{ width: '100%' }}>
        <OutlinedInput
          readOnly
          onClick={handleOpen}
          value={
            minPrice && maxPrice
              ? ` ${minPrice} - ${maxPrice}`
              : `${name}`
          }
          sx={{
            borderRadius: '50px',
            backgroundColor: '#f5f5f5',
             fontFamily: "Oswald,Cairo, sans-serif", fontWeight: "300",
            fontSize: '15px',
            color: '#000',
            cursor: 'pointer',
            height: "40px",
            border: "none",
            width: "100%",
            '.MuiOutlinedInput-notchedOutline': {
      border: 'none',
      boxShadow:'rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px'
    },
          }}
        />
      </FormControl>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          style: { padding: 16, minWidth: 350 },
        }}
      >
        <div style={{ backgroundColor: "#f3f3f5", display: "flex", justifyContent: "space-around", padding: "30px", borderRadius: "50px" }}>
          <div>from:{minPrice}{name === "Area" ? <span>m<sup>2</sup></span> : ""}</div>
          <div>to:{maxPrice}{name === "Area" ? <span>m<sup>2</sup></span> : ""}</div></div>
        <div style={{ display: 'flex', justifyContent: 'space-between', paddingBottom: 8 }}>
          <div>
            <div style={{ fontWeight: 'bold', paddingBottom: 4 }}> min</div>
            {array?.map((price) => (
              <div
                key={`${price}-to`}
                style={{
                  padding: '4px 0',
                  cursor: 'pointer',
                  color: price === minPrice ? '#3f51b5' : '#000',
                }}
                
                onClick={() => handleSelectMin(price)}
              >
                {price}{name === "Area" ? <span>m<sup>2</sup></span> : ""}
              </div>
            ))}
          </div>

          <div>
            <div style={{ fontWeight: 'bold', paddingBottom: 4 }}> max</div>
            {array?.map((price) => (
              <div
                key={`${price}-from`}
                style={{
                  padding: '4px 0',
                  cursor: 'pointer',
                  color: price === maxPrice ? '#3f51b5' : '#000',
                }}
                
                onClick={() => handleSelectMax(price)}
              >
                {price}{name === "Area" ? <span>m<sup>2</sup></span> : ""}
              </div>
            ))}

          </div>
        </div>

        <Button
          fullWidth
          variant="contained"
          onClick={handleClose}
          sx={{
            borderRadius: '30px',
            marginTop: 2,
            textTransform: 'none',
            fontWeight: 'bold',
          }}
        >
          Show
        </Button>
      </Menu>
    </>
  );
}
